import axios from './../../libs/api.request'

export function meta () {
  return axios.request({
    url: '/merchant/meta',
    method: 'get'
  })
}

export function add (data) {
  return axios.request({
    url: '/merchant/add',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/components/merchant/merchantApi.js